<template>
    <div class="flex flex-col items-center">

        <p class="mb-2 mt-20 text-lg font-semibold text-black">
            {{ t('emptyProjects.generateReport') }}
        </p>

        <p class="mb-5 w-[580px] text-center text-sm text-grey-450">
            {{ t('emptyProjects.analyzeTechBackground') }}
        </p>

        <div
            class="project-empty flex h-[220px] w-[580px] items-center justify-center border border-dashed border-eureka-500">
            <button class="th-btn th-btn-xl" @click="addProject">
                <PtIcon class="th-btn-icon text-2xl" icon="SolidAddLarge" />
                {{ t('createProject') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz'
import { useI18n } from 'vue-i18n';
import '@patsnap-ui/icon/assets/solid/AddLarge.svg'

const { t } = useI18n()

const emits = defineEmits<{
    (e: 'addProject'): void
}>()

function addProject() {
    emits('addProject');
}

</script>

<style lang="scss">
.project-empty {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('@/assets/images/empty-project.png');
    width: 100%;
    height: 100%;
}
</style>
